import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './RichTextEditor.css';

const RichTextEditor = ({ value, onChange, placeholder = 'Write your article or educational post here...' }) => {
  // Comprehensive Word / Google Docs style toolbar configuration
  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ font: [] }, { size: ['small', false, 'large', 'huge'] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        [{ align: [] }],
        ['blockquote', 'code-block'],
        ['link', 'image'],
        ['clean']
      ]
    }
  }), []);

  const formats = [
    'font', 'size', 'header',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'script',
    'list', 'bullet', 'indent',
    'align',
    'blockquote', 'code-block',
    'link', 'image'
  ];

  // Helper metrics
  const cleanText = (value || '').replace(/<[^>]*>?/gm, '').trim();
  const wordCount = cleanText ? cleanText.split(/\s+/).filter(Boolean).length : 0;
  const charCount = cleanText.length;
  const readTimeMin = Math.ceil(wordCount / 200) || 1;

  return (
    <div className="word-editor-container">
      <div className="editor-top-info d-flex justify-content-between align-items-center px-3 py-2 bg-light border-bottom">
        <div className="d-flex align-items-center gap-2">
          <i className="fa-regular fa-file-lines text-teal"></i>
          <span className="small fw-semibold text-navy">Document Editor</span>
          <span className="badge bg-white text-muted border small">WYSIWYG</span>
        </div>
        <div className="editor-stats small text-muted d-flex align-items-center gap-3">
          <span><strong>{wordCount}</strong> words</span>
          <span><strong>{charCount}</strong> chars</span>
          <span><i className="fa-regular fa-clock me-1 text-teal"></i> ~{readTimeMin} min read</span>
        </div>
      </div>

      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        className="word-quill-instance"
      />
    </div>
  );
};

export default RichTextEditor;
